import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import LocationLegacy from './LocationLegacy';
import LocationNew from './LocationNew';
import { type LocationProps, type LocationRef } from './types';

const LocationWrapper = ({
  componentRef,
  ...props
}: LocationProps & { componentRef?: React.RefObject<LocationRef> }) => {
  const { flagEvGeoboxSearch } = useFeatureFlag();

  if (flagEvGeoboxSearch) {
    return <LocationNew {...props} componentRef={componentRef} />;
  }

  return <LocationLegacy {...props} componentRef={componentRef} />;
};

export default LocationWrapper;
